<section class="flex flex-column justify-content-center h-full flex-wrap align-content-center">
  <main class="app-card">
    <div class="logo my-4">
      <img src="assets/img/logo-tramitfly.png" alt="Logo tramitFly" class="img-logo"/>
      <img src="assets/img/logo-tramitfly-responsive.png" alt="Logo tramitFly" class="logo-responsive"/>
    </div>
    <div class="flex justify-content-between pt-2 mx-auto gap-4">
      <div class="flex gap-1 align-items-center">
        <i class="pi pi-calendar" style="font-size: 1.4rem; color: var(--gray);"></i>
        <p class="text-gray my-0" style="font-size:13px"> {{ currentTime | date: 'dd/MM/YYYY' }} </p>
      </div>
      <div class="flex gap-1 align-items-center">
        <i class="pi pi-clock text-gray" style="font-size: 1.4rem;"></i>
        <p class="text-gray my-0" style="font-size:13px"> {{ currentTime | date: 'HH:mm' }} </p>
      </div>
      <div class="flex gap-1 align-items-center">
        <i class="pi pi-globe text-gray" style="font-size: 1.4rem;"></i>
        <p class="text-gray my-0" style="font-size:11px"> {{ location }} </p>
      </div>
    </div>
    <div class="flex justify-content-center flex-column align-items-center">
      <h3 class="font-bold mt-4 color-blue-2 " style="font-size:1.7rem;">{{translations.welcome}}</h3>
      <h6 class="font-normal color-blue-2 my-0" style="font-size:1.3rem;">{{translations.message}}</h6>
    </div>
    <form [formGroup]="loginForm" class="flex flex-column formgrid p-fluid  w-full mt-5" (submit)="onSubmit()">
      <div class="field">
        <div class="inline-flex align-items-center  input-wrapper pl-3 w-full">
          <i class="pi pi-user label-form"></i>
          <input pInputText formControlName="correo" id="correo" [placeholder]="translations.usuario"
                 class="w-full ml-2 border-0 font-normal label-form"
                 type="text"/>
        </div>

        <ng-container *ngIf="loginForm.get('correo')?.invalid && loginForm.get('correo')?.touched">
          <small id="correo-help" class="p-error block">
            {{ translations.campoRequerido }}
          </small>
        </ng-container>
      </div>
      <div class="field flex flex-column">

        <div class="inline-flex align-items-center input-wrapper pl-3 w-full">
          <i class="pi pi-lock label-form"></i>
          <p-password id="password" formControlName="password" [toggleMask]="true" [feedback]="false"
                      [placeholder]="translations.password" inputStyleClass="w-full border-0 label-form font-normal"
                      styleClass="w-full" class="w-full ml-2 ">
          </p-password>
        </div>
        <ng-container *ngIf="loginForm.get('password')?.invalid && loginForm.get('password')?.touched">
          <small class="p-error block">
            {{ translations.campoRequerido }}
          </small>
        </ng-container>
      </div>

      <button pButton type="submit"
              class=" mt-3 tax-app-button w-12rem mx-auto">
        <span class="text-medium font-principal" style="font-size:1.3rem">{{ translations.btnIniciarSesion }}</span>
      </button>
      <div class="flex justify-content-center gap-3 mt-4">
        <a class="color-secondary cursor-pointer" (click)="recuperarContrasena()">
          {{ translations.recuperarPsw }}
        </a>
      </div>
    </form>
  </main>

</section>
